<div class="d-flex align-item-center">
  <ng-container *ngIf="iconConfig?.icon; else textView">
    <div
      class="driver-status-icon icon-view d-flex align-item-center justify-content-center"
      [ngStyle]="{ color: iconConfig[currentThemeSubject | async]?.color }"
    >
      <fb-icon *ngIf="!iconConfig?.externalIcon" [width]="24" [iconName]="iconConfig?.icon"></fb-icon>
      <mat-icon *ngIf="iconConfig?.externalIcon" fontSet="material-symbols-outlined">{{ iconConfig?.icon }}</mat-icon>
    </div>
  </ng-container>
  <ng-template #textView>
    <div
      class="driver-status-icon"
      [ngClass]="size"
      [ngStyle]="{
        'background-color': iconConfig[currentThemeSubject | async]?.bg,
        color: iconConfig[currentThemeSubject | async]?.color
      }"
    >
      <span>{{ iconConfig?.text }}</span>
    </div>
  </ng-template>
</div>
